export default "__VITE_ASSET__DH4Ge$xt__"